import { MenuItem } from '@headlessui/react'
import React, { useState } from 'react'
import { FaCaretDown, FaWhatsapp } from 'react-icons/fa'
import { MyLink } from '../MyLink'
import { whatsAppDisplay, whatsAppUrl } from 'utils/business-info'

export const AirconNavBarSmall = ({waInd}) => {

    const [ isExpandAirconService, setIsExpandAirconService ] = useState(false)
    const [ isExpandAirconProblem, setIsExpandAirconProblem ] = useState(false)
    const [ isExpandAirconBrands, setIsExpandAirconBrands ] = useState(false)

  return (
    <>
        <li>
            <div className="flex justify-center">
                <button
                type="button"
                onClick={() => setIsExpandAirconService(!isExpandAirconService)}
                className="flex justify-center items-center px-2 py-2 text-orange-600"
                aria-expanded={isExpandAirconService}
                aria-controls="aircon-services-menu"
                aria-haspopup="true"
                >
                    Services <FaCaretDown className="h-5 w-5 ml-1" />
                </button>
            </div>

            {isExpandAirconService && (
                <ul id="aircon-services-menu" role="menu" className="relative">
                {[
                    {
                    href: "/sg/aircon-servicing-singapore/cleaning-maintenance-service",
                    label: "AC General Service",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-chemical-wash-and-overhaul",
                    label: "Chemical Wash & Overhaul",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-repair",
                    label: "Aircon Repair",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/urgent-aircon-servicing",
                    label: "Urgent Servicing & Repair",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-condenser-cleaning",
                    label: "Compressor Cleaning",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-gas-top-up",
                    label: "Gas Top Up",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-installation",
                    label: "AC Installation",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-parts-replacement",
                    label: "Parts Replacement",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/annual-package",
                    label: "Annual Package Service",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/ceiling-cassette-aircon-service",
                    label: "Cassette Aircon Servicing",
                    },
                ].map((item, index) => (
                    <MenuItem key={index} role="menuitem">
                    <MyLink
                        href={item.href}
                        prefetch={false}
                        className="text-orange-500 text-sm p-2 block"
                        aria-label={`Learn more about ${item.label}`}
                    >
                        {item.label}
                    </MyLink>
                    </MenuItem>
                ))}
                </ul>
            )}
        </li>

        <MenuItem role="menuitem">
            <MyLink
                href="/sg/aircon-servicing-singapore/aircon-servicing-price-singapore"
                prefetch={false}
                className="flex justify-center px-2 py-2 text-orange-600"
                aria-current="page"
                aria-label="View aircon service pricing in Singapore"
            >
                Pricing
            </MyLink>
        </MenuItem>

        <li>
            <div className="flex justify-center">
                <button
                type="button"
                onClick={() => setIsExpandAirconProblem(!isExpandAirconProblem)}
                className="flex justify-center items-center px-2 py-2 text-orange-600"
                aria-expanded={isExpandAirconProblem}
                aria-controls="aircon-problems-menu"
                aria-haspopup="true"
                >
                    Aircon Problems <FaCaretDown className="h-5 w-5 ml-1" />
                </button>
            </div>

            {isExpandAirconProblem && (
                <ul id="aircon-problems-menu" role="menu" className="relative">
                {[
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-leaking-water",
                    label: "Water Leaking",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-not-cooling",
                    label: "Insufficient Cooling",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/do-this-when-your-aircon-stops-working-suddenly",
                    label: "Aircon Won't Turn On",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-overheating",
                    label: "Aircon Overheating",
                    },
                    {
                    href: "/sg/aircon-servicing-singapore/aircon-gas-leakage",
                    label: "Gas Leakage",
                    },
                ].map((item, index) => (
                    <MenuItem key={index} role="menuitem">
                    <MyLink
                        href={item.href}
                        prefetch={false}
                        className="text-orange-500 text-sm p-2 block"
                        aria-label={`Read about ${item.label}`}
                    >
                        {item.label}
                    </MyLink>
                    </MenuItem>
                ))}
                </ul>
            )}
        </li>
        <li>
            <div className="flex justify-center">
                <button
                type="button"
                onClick={() => setIsExpandAirconBrands(!isExpandAirconBrands)}
                className="flex justify-center items-center px-2 py-2 text-orange-600"
                aria-expanded={isExpandAirconBrands}
                aria-controls="aircon-brands-menu"
                aria-haspopup="true"
                >
                    Air-Con Brands <FaCaretDown className="h-5 w-5 ml-1" />
                </button>
            </div>

            {isExpandAirconBrands && (
                <ul id="aircon-brands-menu" role="menu" className="relative">
                {[
                    {
                        href: "/sg/aircon-servicing-singapore/daikin",
                        label: "Daikin",
                    },
                    {
                        href: "/sg/aircon-servicing-singapore/lg-air-conditioner",
                        label: "LG",
                    },
                    {
                        href: "/sg/aircon-servicing-singapore/mitsubishi-electric",
                        label: "Mitsubishi Electric",
                    },
                    {
                        href: "/sg/aircon-servicing-singapore/panasonic",
                        label: "Panasonic",
                    },
                    {
                        href: "/sg/aircon-servicing-singapore/professional-prism-aircon-servicing-in-singapore",
                        label: "Prism+",
                    },
                    {
                        href: "/sg/aircon-servicing-singapore/samsung",
                        label: "Samsung",
                    }
                ].map((brand, index) => (
                    <MenuItem key={index} role="menuitem">
                    <MyLink
                        href={brand.href}
                        prefetch={false}
                        className="text-orange-500 text-sm p-2 block"
                        aria-label={`Visit ${brand.label} page`}
                    >
                        {brand.label}
                    </MyLink>
                    </MenuItem>
                ))}
                </ul>
            )}
        </li>
        <MenuItem>
            <MyLink href="/sg/blogs/hvac-services"
                    prefetch={false} className="flex justify-center px-2 py-2 text-orange-600" aria-label="Aircon Services Blogs">
                Blogs                       
            </MyLink>            
        </MenuItem>
        <MenuItem as="li">
             {/* Primary contact CTA - server rendered so the number is crawlable */}
            <div className='flex justify-center pb-3'>
                <a
                    href={`${whatsAppUrl}?text=${encodeURIComponent("Hi, I'd like to book aircon servicing.")}`}
                    target='_blank'
                    rel='noreferrer'
                    aria-label='WhatsApp StringsSG to book aircon servicing'
                    className='flex items-center gap-2 bg-linear-to-tr from-green-700 to-green-500 text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-lg'
                >
                    <FaWhatsapp className='text-base' />
                    WhatsApp {whatsAppDisplay}
                </a>
            </div>
        </MenuItem>
    </>
  )
}
